// extracted by mini-css-extract-plugin
export default {"btnPrev":"Slider_btnPrev__Ypway","btnNext":"Slider_btnNext__EfT3a"};